import services from './../../../services/service'; // Service Class
import MainFooter from './../../MainFooter/index.vue'; // Main Footer ///for empty cart page
import CartWidget from '../CartWidget/index.vue'

let service = new services();
// import ProductForm from '../../../components/product/ProductForm.vue'
// import ProductItemForm from '../../../components/product/ProductItemForm.vue'
// import ProductCartActions from '../../../components/product/ProductCartActions.vue'

//let service = new services();

import {
  ADD_TO_CART,
  REMOVE_FROM_CART
} from '../../../store/mutation-types'
export default {
    name: 'Cart',
    data () {
        return {
          loading:false,
          user: {},
          cart: this.$store.state.cart,
          img_product_url: service.imageProductsURL,
          loggedIn:false,
        }
      },
    components: {
       'cart-widget': CartWidget,
       'component-footer':MainFooter
      },
    computed: {
       
    },
    methods:{
        
    

    },
    created(){
        document.title = "Cart" + " | SP";
    }
     
}


// WEBPACK FOOTER //
// ./src/pages/Orderpoint/Cart/script.js